import { Add } from '@shared/assets';
import { IconButton } from '@shared/ui/buttons';
import { useNoteTools } from '../model/hooks';
import { AddImgButton } from './add-img-button';
import { AddLinkButton } from './add-link-button';
import st from './styles.module.scss';

interface Props {
  positionY: number;
}

export const NoteEditorTools: React.FC<Props> = ({ positionY }) => {
  const { isOpenTools, switchOpenTools } = useNoteTools();

  return (
    <div
      className={st.manageWrapper}
      style={{
        left: '25px',
        top: `${positionY}px`,
        // transform: `translate3d(${25}px, ${positionY}px, 0)`,
      }}
    >
      <IconButton
        variant="white"
        type="button"
        onClick={switchOpenTools}
        className={st.manage_btn}
        style={{
          transform: `rotate(${isOpenTools ? 45 : 0}deg)`,
        }}
      >
        <Add />
      </IconButton>
      {isOpenTools && (
        <div className={st.toolsWrapper}>
          <AddImgButton />
          <AddLinkButton />
        </div>
      )}
    </div>
  );
};
